import React, { useEffect, useState } from 'react';
import { Card, CardBody } from 'reactstrap';
import { Link, useParams } from 'react-router-dom';
import Layout from '../components/Layout';
import Prompt from '../components/Prompt';
import { CheckpointMatrix, Comparison, Picks } from '../components/Tables';
import { request } from '../api';

const STATUS = { pending: 'Waiting for its first checkpoint', tracking: 'Tracking', settled: 'All checkpoints settled' };

export default function PredictionDetail() {
  const { id } = useParams(), [data, setData] = useState(null), [error, setError] = useState('');
  useEffect(() => {
    let live = true;
    setData(null); setError('');
    request(`/predictions/${id}`).then(d => live && setData(d)).catch(e => live && setError(e.message));
    return () => { live = false; };
  }, [id]);
  const p = data?.predictions.find(x => x.id === id), b = data?.batch, checkpoints = data?.strategy?.checkpoints || [];
  const open = b && b.status === 'pending' && new Date() < new Date(b.submission_deadline);
  return <Layout title={p ? `${p.model_name} · multibagger picks` : 'Prediction detail'} error={error}>{p && <>
    <p>{STATUS[b.status] || b.status} · Asked {b.prediction_time} · Measured at {checkpoints.map(c => c.label).join(', ')} against {data.strategy.benchmark}</p>
    <Card><CardBody>
      <h5 className="card-title mb-3">Results by checkpoint</h5>
      <CheckpointMatrix selections={p.selections} results={p.results} checkpoints={checkpoints} />
    </CardBody></Card>
    <Card><CardBody>
      {p.market_view && <p className="text-muted">{p.market_view}</p>}
      <Picks selections={p.selections} screens={data.strategy.screens} answers={data.consensus.answers} />
      <p className="text-muted fs-12 mb-0">Screens: {Object.entries(data.strategy.screens).map(([n, label]) => `${n} ${label}`).join(' · ')}. Screen 6 is required; the rest are preferred.</p>
    </CardBody></Card>
    {data.consensus.answers > 1 && <Card><CardBody>
      <h5 className="card-title mb-2">Consensus in this batch</h5>
      {data.consensus.shared.length ? <ul className="mb-0">{data.consensus.shared.map(e => <li key={e.symbol}><strong>{e.symbol}</strong> — picked by {e.count} of {data.consensus.answers} models: {e.models.join(', ')}</li>)}</ul>
        : <p className="text-muted mb-0">No stock was picked by more than one of the {data.consensus.answers} models.</p>}
    </CardBody></Card>}
    <Card><CardBody><h5 className="card-title mb-3">Models in this experiment — excess over {data.strategy.benchmark}</h5><Comparison predictions={data.predictions} checkpoints={checkpoints} /></CardBody></Card>
    {data.can_manage && open && <p><Link className="btn btn-soft-primary btn-sm" to={`/multibagger-selection/create?batch=${b.id}`}><i className="ri-add-line align-bottom me-1"/>Add a model</Link></p>}
    {b.prompt ? <details><summary>Standardized prompt</summary><Prompt text={b.prompt} /></details>
      : <p className="text-muted fs-12"><i className="ri-lock-2-line me-1" />The standard prompt is ForecastNest's own research method and is not published.</p>}
    <details><summary>Original model response and normalized data</summary><pre>{p.raw_response}</pre><pre>{JSON.stringify(p.normalized_json, null, 2)}</pre></details>
    {!!data.checkpoints.length && <details><summary>Settlement prices</summary>{data.checkpoints.map(c => <div key={c.checkpoint}><p className="mb-1">{c.checkpoint} · to {c.end_at} · settled {c.settled_at} · {c.calculation_version}</p><pre>{JSON.stringify(c.prices_json, null, 2)}</pre></div>)}</details>}
  </>}</Layout>;
}
